import { TFunction } from 'i18next';

import { isNullOrUndefined } from 'helpers/utils';
import { SUCCESS, WARNING, ERROR, INFO } from 'attrs/status';
import { NotifyIcon } from 'web-components';
import { NOTIFICATION_COLORS } from 'attrs/colors';

const variantIcon = {
  [SUCCESS]: <NotifyIcon iconName="checkmark" style={{ color: NOTIFICATION_COLORS[SUCCESS], marginRight: '.5rem' }} />,
  [WARNING]: <NotifyIcon iconName="warning" style={{ color: NOTIFICATION_COLORS[WARNING], marginRight: '.5rem' }} />,
  [ERROR]: <NotifyIcon iconName="error" style={{ color: NOTIFICATION_COLORS[ERROR], marginRight: '.5rem' }} />,
  [INFO]: <NotifyIcon iconName="info" style={{ color: NOTIFICATION_COLORS[INFO], marginRight: '.5rem' }} />
};

type NotificationType = typeof SUCCESS | typeof WARNING | typeof ERROR | typeof INFO;

interface Variable {
  name: string;
  data: string;
}

// TODO: it will be made inside our web-components-ts with the Provider component
export function createMessage(
  message: string,
  type: NotificationType,
  t: TFunction,
  variables?: Variable[]
): JSX.Element {
  let text = t(message);
  if (!isNullOrUndefined(variables) && Array.isArray(variables)) {
    const obj: Record<string, string> = {};
    variables.forEach(variable => {
      obj[variable.name] = variable.data;
    });
    text = t(message, obj);
  }

  return (
    <span style={{ display: 'flex', alignItems: 'center' }}>
      {variantIcon[type]}
      {text}
    </span>
  );
}
